export default {
  namespaced: true,
  state: {
    track: null,
    status: 'paused',
    command: 'pause'
  },
  getters: {
    track: state => state.track,
    command: state => state.command,
    isPlaying: state => state.status === 'playing',
    isPaused: state => state.status === 'paused',
  },
  actions: {
    playTrack: ({ dispatch, commit }, payload = null) => {
      commit('setTrack', JSON.parse(JSON.stringify(payload)))
      dispatch('executeCommand', 'load')
    },
    play: ({ commit }) => {
      commit('setPlaying', true)
    },
    pause: ({ commit }) => {
      commit('setPlaying', false)
    },
    stop: ({ commit }) => {
      commit('setPlaying', false)
      commit('setTrack', null)
    },
    executeCommand: ({ commit }, payload) => {
      commit('setCommand', payload)
    }
  },
  mutations: {
    setTrack: (state, payload) => {
      state.track = payload
    },
    setPlaying: (state, payload) => {
      state.status = payload ? 'playing' : 'paused'
    },
    setCommand: (state, payload) => {
      state.command = payload
    },
  }
}
